// removed by extract-text-webpack-plugin
module.exports = {"root":"_3XhOvPa7e4qKJdi4FfQ3tL","snakeRoot":"_3MYYOZj17sSoWZDelx6OrF _3XhOvPa7e4qKJdi4FfQ3tL","header":"_18P_9Hyp8zSorKBs4_E8M3","column":"_1oI3h-3RFXkocIt8bfZqfZ","itemWrapper":"_248dL0q25LP4YwYNNEHB4u","item":"_3UFmn48KjBmy6SMkn5Pse2","loader":"_3s7RE-caWxv1PdvfDjtEHX _248dL0q25LP4YwYNNEHB4u","ulClass":"_3xuYu3WFMupr49tw4nwEST","activeClass":"_2UL7fn-KR6gI3UbG2JzPm6","paginationCss":"_1KkaesqhFiEPPJ4kRtly07","actionToolbar":"eO7U9PzLvuBBnIdzbz4yX","bigListButton":"_2F5zV_Nh08QPsXAb1EsO3e"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BigList/style.css
// module id = 1054
// module chunks = 0